'use strict';

module.exports = darc.compile({
	name: darc.types.primary(String),
	url: String,

	tutorialId: String,
	video: Number,

	usesVimeo: function() {
		return this.url().match(/^[0-9]+$/);
	}
});

module.exports.Set = darc.compile(darc.types.set(module.exports.schema));
